import { defineMessages } from 'react-intl';

export default defineMessages({
    concurrentDataChange: {
        id: 'ml.common.readable-error-util.Concurrent Data Change Exception. Please try your change again.',
        defaultMessage: 'Concurrent Data Change Exception. Please try your change again.'
    },
    policyChangePreemption: {
        id: 'ml.common.readable-error-util.Policy Change Preemption Exception',
        defaultMessage: 'Your policy change was preempted by {transactionNumber}. ' +
            'Please withdraw all open policy changes or contact us to handle these preemptions before continuing.'
    }
});